import React from 'react';
import {browserHistory, Redirect, Route, Router} from 'react-router';
import * as Sentry from "@sentry/react";
import AnimalListPage from '../modules/AnimalList/components/AnimalListPage';
import OldProtectoraDetailPage from '../modules/Protectora/components/ProtectoraDetail/OldProtectoraDetailPage';
import LoginPage from '../modules/AdminProtectora/components/Login/LoginPage';
import RegistroProtectoraPage from '../modules/Protectora/components/RegistroProtectora/RegistroProtectoraPage';
import RegistroGraciasPage from '../modules/Protectora/components/RegistroProtectora/RegistroGraciasPage';
import RegistroEmailVerificadoPage from '../modules/Protectora/components/RegistroProtectora/RegistroEmailVerificadoPage';
import Error_404_not_found from '../modules/Structure/components/errores/Error_404_not_found';
import AdminHallPage from '../modules/AdminProtectora/components/AdminHallPage';
import AdminPerfilPage from '../modules/AdminProtectora/components/AdminPerfilPage';
import FormAnimalPage from '../modules/Animal/components/FormAnimal/FormAnimalPage';
import AnimalDetailPage from '../modules/Animal/components/AnimalDetail/AnimalDetailPage';
import ChangePasswordPage from '../modules/AdminProtectora/components/ChangePasswordPage';
import ContactLandingPage from '../modules/Shared/components/Contact/ContactUsLanding/ContactUsLandingPage';
import EntityListPage from "../modules/EntityList/components/EntityListPage";
import NewProtectoraDetailPage from "../modules/Protectora/components/ProtectoraDetail/NewProtectoraDetailPage";
import EntityDetailPage from "../modules/Entity/components/EntityDetailPage";
import {syncHistoryWithStore} from 'react-router-redux';
import ReactGA4 from 'react-ga4';
import ReactGA from 'react-ga';
import PanelServicios from "../modules/AdminProtectora/components/Servicios/PanelServiciosPage";
import {ELEMENTS, TIPOS_EVENTOS} from "../analytics/config/analyticsParamsFrontEnd";
import {sendEvent} from "../analytics/analitycs"

export const PATH_ADOPTAR = "/adoptar";
export const PATH_ADOPTAR_ID = "/adoptar/";

export const PATH_PROTECTORA_ID = "/protectora/";

export const PATH_BUSCADOR_ANIMALES_CONTACTA_CON_NOSTROS = "/buscador/contacta-con-nosotros";

export const PATH_BUSCADOR_ANIMALES_ADMIN = "/buscador/admin";
export const PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL = "/buscador/admin/perfil";
export const PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID = "/buscador/admin/adminAnimals/";
export const PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO = "/buscador/admin/animal/nuevo";
export const PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID = "/buscador/admin/animal/";
export const PATH_BUSCADOR_ANIMALES_ADMIN_CAMBIAR_CONTRASENA = "/buscador/admin/cambiar-contraseña";
export const PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN = "/buscador/admin/login";
export const PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO = "/buscador/admin/registro";
export const PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_GRACIAS = "/buscador/admin/registro/gracias";
export const PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_OFERTA_LANZAMIENTO = "/buscador/admin/registro/oferta_lanzamiento";
export const PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_OFERTA_LANZAMIENTO_GRACIAS = "/buscador/admin/registro/oferta_lanzamiento_gracias";
export const PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_EMAIL_VERIFICADO = "/buscador/admin/registro/emailVerificado";
export const PATH_BUSCADOR_ANIMALES_ADMIN_SERVICIOS = "/buscador/admin/servicios";

export const PATH_BUSCADOR_PETFRIENDLY_tipo_subtipo_prov_municipio_top = "/buscador/:tipo_entity/:subtipo_entity/:prov/:municipio/:top";
export const PATH_BUSCADOR_PETFRIENDLY_tipo_subtipo_prov_municipio = "/buscador/:tipo_entity/:subtipo_entity/:prov/:municipio";
export const PATH_BUSCADOR_PETFRIENDLY_tipo_subtipo_prov = "/buscador/:tipo_entity/:subtipo_entity/:prov";
export const PATH_BUSCADOR_PETFRIENDLY_tipo_subtipo = "/buscador/:tipo_entity/:subtipo_entity";


export const PATH_BUSCADOR_PETFRIENDLY_ROOT = "/buscar-pet-friendly";
export const PATH_BUSCADOR_PETFRIENDLY_ROOT_PAG_PATTERN = "/buscar-pet-friendly(/pag-:pagina)";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO = "/buscar-pet-friendly/:tipo_entitys";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_PAG = "/buscar-pet-friendly/:tipo_entitys/pag-:pagina";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_PATTERN = "/buscar-pet-friendly(/:tipo_entity)s";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO = "/buscar-pet-friendly/:tipo_entitys/:subtipo_entity";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PATTERN = "/buscar-pet-friendly(/:tipo_entity)s(/:subtipo_entity)";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA = "/buscar-pet-friendly/:tipo_entitys/:subtipo_entity/en-:provincia";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_PATTERN = "/buscar-pet-friendly(/:tipo_entity)s(/:subtipo_entity)(/en-:provincia)";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO = "/buscar-pet-friendly/:tipo_entitys/:subtipo_entity/en-:provincia/cerca-de-:municipio/";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO_PATTERN = "/buscar-pet-friendly(/:tipo_entity)s(/:subtipo_entity)(/en-:provincia)(/cerca-de-:municipio)(/)";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO_PAG = "/buscar-pet-friendly/:tipo_entitys/:subtipo_entity/en-:provincia/cerca-de-:municipio/pag-:pagina";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO_PAG_PATTERN = "/buscar-pet-friendly(/:tipo_entity)s(/:subtipo_entity)(/en-:provincia)(/cerca-de-:municipio)(/pag-:pagina)(/)";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO_TOP = "/buscar-pet-friendly/:tipo_entitys/:subtipo_entity/en-:provincia/cerca-de-:municipio/top-:top";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO_TOP_PATTERN = "/buscar-pet-friendly(/:tipo_entity)s(/:subtipo_entity)(/en-:provincia)(/cerca-de-:municipio)(/top-:top)";

export const PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA = "/buscar-pet-friendly/:tipo_entitys/en-:provincia";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_PATTERN = "/buscar-pet-friendly(/:tipo_entity)s(/en-:provincia)";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO = "/buscar-pet-friendly/:tipo_entitys/en-:provincia/cerca-de-:municipio";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO_PATTERN = "/buscar-pet-friendly(/:tipo_entity)s(/en-:provincia)(/cerca-de-:municipio)";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO_PAG = "/buscar-pet-friendly/:tipo_entitys/en-:provincia/cerca-de-:municipio/pag-:pagina";
export const PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO_PAG_PATTERN = "/buscar-pet-friendly(/:tipo_entity)s(/en-:provincia)(/cerca-de-:municipio)(/pag-:pagina)";

export const PATH_BUSCADOR_PETFRIENDLY_PROVINCIA = "/buscar-pet-friendly/en-:provincia";
export const PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_PATTERN = "/buscar-pet-friendly(/en-:provincia)";
export const PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO = "/buscar-pet-friendly/en-:provincia/cerca-de-:municipio";
export const PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO_PATTERN = "/buscar-pet-friendly(/en-:provincia)(/cerca-de-:municipio)";
export const PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO_PAG = "/buscar-pet-friendly/en-:provincia/cerca-de-:municipio/pag-:pagina";
export const PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO_PAG_PATTERN = "/buscar-pet-friendly(/en-:provincia)(/cerca-de-:municipio)(/pag-:pagina)";


// export const PATH_BUSCADOR_PETFRIENDLY_DETAIL_PATTERN = "/buscar-pet-friendly/:tipo_entity/:id";
export const PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN = "/buscar-pet-friendly/:tipo_entity/:permalink";

// export const PATH_BUSCADOR_PETFRIENDLY_ROOT = "/buscador";
export const PATH_PROTECTORAS = "/protectoras";

export const PATH_BUSCADOR_ERROR_404 = "/buscador/error/404";


// el Store que creamos antes
// import configStore from '../../reducers/index';

let root_buscar_pet_friendly_regexp = "^/?buscar-pet-friendly"
let tipo_regexp = "(/[\\wÀ-ÿ\\u00f1\\u00d1-]*s)"
let tipo_entity_detail_regex = "(/[\\wÀ-ÿ\\u00f1\\u00d1-]*)"
let permalink = "(/[\\wÀ-ÿ\\u00f1\\u00d1-]*)\/"
let subtipo_regexp = "(/[^en-][\\wÀ-ÿ\\u00f1\\u00d1-]*)"
let provincia_regexp = "(/en-[a-zA-ZÀ-ÿ\\u00f1\\u00d1-]*)"
let municipio_regexp = "(/cerca-de-[a-zA-ZÀ-ÿ\\u00f1\\u00d1-]*)"
let pagina_regexp = "(/pag-[0-9]{1,2})"
const PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO_PAG_REGEXP = tipo_regexp + provincia_regexp + "?" + municipio_regexp + "?"
const PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO_PAG_REGEXP = tipo_regexp + subtipo_regexp + permalink + "?"
export const PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_REGEXP = root_buscar_pet_friendly_regexp + tipo_entity_detail_regex + "?" + municipio_regexp + "?"


class RouterAdopta extends React.Component {
    
    constructor(props) {
        super(props);
        this.history = syncHistoryWithStore(browserHistory, props.store);
        this.history.listen((location) => {
            try {
                console.info('-> location: ', location.pathname);
                if (process.env.NODE_ENV === 'production' && (process.env.DEV_ENV === 'DEMO' || process.env.DEV_ENV === 'PRO')) {
                    ReactGA.pageview(location.pathname);
                    ReactGA4.send({hitType: "pageview", page: location.pathname});
                }
                // if (new RegExp(root_buscar_pet_friendly_regexp, "gmi").test(location.pathname)) {
                // debugger
                if (new RegExp(root_buscar_pet_friendly_regexp + tipo_regexp + "?", "gmi").test(location.pathname) ||
                    new RegExp(root_buscar_pet_friendly_regexp + provincia_regexp + "?", "gmi").test(location.pathname)) {
                    console.log("Buscador permalink = '" + location.pathname + "'");
                    sendEvent(TIPOS_EVENTOS.PAGEVIEW, ELEMENTS.BUSCADOR.BUSCADOR, {permalink: location.pathname})
                    
                } else {
                    if (new RegExp(root_buscar_pet_friendly_regexp + tipo_entity_detail_regex + "?").test(location.pathname)) {
                        const permalink = location.pathname.replace(new RegExp(root_buscar_pet_friendly_regexp + tipo_entity_detail_regex + "?"), "")?.split("?")[0]
                        console.log("Entity permalink = '" + permalink + "'");
                        sendEvent(TIPOS_EVENTOS.PAGEVIEW, ELEMENTS.ENTITY.ENTITY, {permalink})
                    }
                }
                // }
            } catch (e) {
                Sentry.captureException(e);
            }
        });
    }
    
    render() {
        return (
            <Router history={this.history}>
                
                
                {/*<Route exact path="/" component={Home}/>*/}
                {/*<Route exact path="/" component={AnimalListPage}/>*/}
                <Route path={PATH_ADOPTAR} component={AnimalListPage}/>
                <Route path={PATH_ADOPTAR_ID + ":id"} component={AnimalDetailPage}/>
                <Route path={PATH_PROTECTORA_ID + ":id"} component={NewProtectoraDetailPage}/>
                {/*<Route path={PATH_PROTECTORA_ID + ":id"} component={OldProtectoraDetailPage}/>*/}
                <Route path={PATH_BUSCADOR_ANIMALES_CONTACTA_CON_NOSTROS} component={ContactLandingPage}/>
                
                
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN} component={AdminHallPage}/>
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL} component={AdminPerfilPage}/>
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID + ":id"} component={OldProtectoraDetailPage}/>
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO} component={FormAnimalPage}/>
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID + ":id"} component={FormAnimalPage}/>
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_CAMBIAR_CONTRASENA} component={ChangePasswordPage}/>
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN} component={LoginPage}/>
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO}
                       component={() => <RegistroProtectoraPage title="¡Nos encanta verte por aquí!"
                                                                thanksPage={PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_GRACIAS}
                                                                showOkPolitica={true}/>
                       }
                />
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_GRACIAS} component={RegistroGraciasPage}/>
                
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_OFERTA_LANZAMIENTO}
                       component={() => <RegistroProtectoraPage title="¡Registro oferta pack lanzamiento!"
                                                                thanksPage={PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_OFERTA_LANZAMIENTO_GRACIAS}
                                                                showOkPolitica={false}/>
                       }/>
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_OFERTA_LANZAMIENTO_GRACIAS}
                       component={RegistroGraciasPage}/>
                
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO_EMAIL_VERIFICADO}
                       component={RegistroEmailVerificadoPage}/>
                
                <Route path={PATH_BUSCADOR_ERROR_404} component={Error_404_not_found}/>
                <Route path={PATH_BUSCADOR_ANIMALES_ADMIN_SERVICIOS} component={PanelServicios}/>
                
                {/*Redirecciones por cambio de paths 21/09/2021 */}
                <Redirect exact path="/contacta-con-nosotros" to={PATH_BUSCADOR_ANIMALES_CONTACTA_CON_NOSTROS}/>
                <Redirect exact path="/admin/*" to="/buscador/admin/*"/>
                
                
                {/* todo revisar que esto fundiona bien cuando se está en la tienda y demlas */}
                {/* paths para los listings de entidades */}
                <Route path={PATH_BUSCADOR_PETFRIENDLY_ROOT_PAG_PATTERN} component={EntityListPage}/>
                
                <Route path={PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO_PAG_PATTERN} component={EntityListPage}/>
                <Route path={PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO_PAG_PATTERN}
                       component={EntityListPage}/>
                <Route path={PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO_PAG_PATTERN}
                       component={EntityListPage}/>
                
                {/* paths para las paginas de entidades */}
                {/*<Route path={PATH_BUSCADOR_PETFRIENDLY_DETAIL_PATTERN} component={EntityDetailPage}/>*/}
                <Route path={PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN} component={EntityDetailPage}/>
                {/*<Route path={"/buscar-pet-friendly(/:tipo_entity)/:permalink"} component={EntityListPage}/>*/}
                {/* Redireccionar el resto de cosas del buscador */}
                <Route path={PATH_BUSCADOR_PETFRIENDLY_ROOT} component={EntityListPage}/>
                
                {/* Redireccionar el resto de cosas */}
                <Redirect exact path="/*" to={PATH_BUSCADOR_PETFRIENDLY_ROOT}/>
            </Router>
        );
    }
    
    componentWillMount() {
    }
    
    componentDidMount() {
    }
}


//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default RouterAdopta
